import { useEffect } from "react"

import {
  Chart,
  setCurrentSymbol,
  TimeframeSelector,
} from "@/App/Equities/shared/components"
import { Stack } from "@/generated/material"

interface Props {
  symbol: string
}

export const InstrumentChart = ({ symbol }: Props) => {
  useEffect(() => {
    setCurrentSymbol(symbol)

    return () => setCurrentSymbol(undefined)
  }, [symbol])

  return (
    <Stack gap="xs">
      <Chart />
      <TimeframeSelector />
    </Stack>
  )
}
